import { ComponentType } from 'react'

/** @public */
export type TLInFrontOfTheCanvas = ComponentType<object>
